import moment from 'moment';
import { DATE_FORMATS } from '../../_constants';
import { exportFile } from './exportFile';

export const exportCSV = (data, filename, isURL) =>
  exportFile(data, 'text/csv', 'csv', `${filename}_${moment(new Date()).format(DATE_FORMATS.WITH_TIME)}`, isURL);
